import ExternalTransportBaseScreen from "../../mapping_tool/UpdateNodes/shared/externalTransport/ExternalTransportBaseScreen";

export const TransportBase = ({ modalData }: { modalData: any }) => (
  <ExternalTransportBaseScreen modalData={modalData} variant="simulate" />
);
